import React from 'react';
import styles from './partner-page/partner-page.module.less';

const gothamBlackRegexGlobal = /\|.*?\|/g; // matches |desired gothamBlack text|
const gothamBlackCaptureRegex = /\|(.*?)\|/; // captures |desired gothamBlack text|
const awardsItalicRegexGlobal = /\^.*?\^/g; // matches // &desired Awards 2021 italicized title text&
const awardsItalicCaptureRegex = /\^(.*?)\^/; // captures // &desired Awards 2021 italicized title text&
const breakRegexGlobal = /:br:/g; // matches :linebreak:
const breakCaptureRegex = /:(br):/; // captures :linebreak:

const SPLIT_CHAR = '%%&&';

const generateStyledOutput = () => (potentialStyledOutput, index) => {
  const gothamBlackMatchResult = potentialStyledOutput.match(
    gothamBlackCaptureRegex
  ); // yields |desired gothamBlack text|

  const awardsItalicMatchResult = potentialStyledOutput.match(
    awardsItalicCaptureRegex
  ); // yields &desired Awards 2021 italicized title text&

  // yields &desired Awards 2021 italicized title text&
  const breakMatchResult = potentialStyledOutput.match(breakCaptureRegex); // yields :linebreak:

  if (gothamBlackMatchResult) {
    const copy = gothamBlackMatchResult[1];

    return (
      <span className={styles.gothamBlackContent} key={`gothamBlack-${index}`}>
        {copy}
      </span>
    );
  }

  if (awardsItalicMatchResult) {
    const copy = awardsItalicMatchResult[1];

    return (
      <span
        className={styles.awardsItalic2023}
        key={`awards-italic-2023-${index}`}
      >
        {copy}
      </span>
    );
  }

  if (breakMatchResult) {
    return <br />;
  }

  // content is not in styled format!
  return potentialStyledOutput;
};

export default (content) => {
  if (typeof content === 'string') {
    // Wrap all styled output in a split character
    const bookmarkedString = content
      .replace(
        gothamBlackRegexGlobal,
        (match) => `${SPLIT_CHAR}${match}${SPLIT_CHAR}`
      )
      .replace(
        awardsItalicRegexGlobal,
        (match) => `${SPLIT_CHAR}${match}${SPLIT_CHAR}`
      )
      .replace(
        breakRegexGlobal,
        (match) => `${SPLIT_CHAR}${match}${SPLIT_CHAR}`
      );
    // Split on split char and map everything you can to styled output
    const result = bookmarkedString
      .split(SPLIT_CHAR)
      .map(generateStyledOutput());
    return result;
  }

  // not parsable
  return content;
};
